
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { SYSAPI } from '@/api/sys'
import { USERAPI } from '@/api/users'
import {
  setuserCurrentApp,
  setRole,
  setuserCurrentAppName,
  getuserCurrentApp,
  getIsSingleEntry,
  removeIsSingleEntry,
  getuserCurrentAppName
} from '@/utils/cookies'
import { AppModule, DeviceType } from '@/store/modules/app'
import { dashboardTicketKeywords } from '@/utils/commonFunc'

@Component({
  components: {}
})
export default class Jumper extends Vue {
  private pageLoading: any = null; // 页面加载中, 相当于蒙层功能，限制用户多次点击无效

  private sysAppDataList: Array<any> = []; // 系统app数据
  private isMobile = false; // 是否为手机端

  mounted() {
    this.isMobile = this.isMobileFunc()

    const appid = getuserCurrentApp()
    const isSingleEntry = getIsSingleEntry()
    const name = getuserCurrentAppName()
    // if (appid && isSingleEntry) {
    //   this.handleClick({
    //     id: +appid,
    //     name: name,
    //     path: '/newOrder/tutor'
    //   })
    // } else {
    this.checkDashPerms().then((_) => {
      this.getSysAppData()
    })
    // }
  }

  private skipToCreateTicket() {
    this.$router.push({ path: '/createIndex' })
  }

  private isMobileFunc() {
    const rect = document.body.getBoundingClientRect()
    const isMobile = rect.width - 1 < 992
    if (isMobile) {
      AppModule.ToggleDevice(DeviceType.Mobile)
      AppModule.CloseSideBar(true)
    }
    return isMobile
  }

  private getSysAppData() {
    this.pageLoading = this.$loading({
      lock: true,
      spinner: 'le',
      background: 'rgba(255, 255, 255, 0.2)'
    })
    const fetch_device = this.isMobile ? 'mobile' : 'pc'
    SYSAPI.getSysApp({ fetch_device: fetch_device }).then((res) => {
      if (res.stat && res.data.length > 0) {
        this.sysAppDataList = res.data
        // console.log(this.sysAppDataList)
      } else {
        this.$alert('获取应用列表失败，请联系管理员！', {
          type: 'warning',
          confirmButtonText: '知道了'
        })
      }
      this.pageLoading.close()
    })
  }

  private handleClick(item: any) {
    const appId = item.id
    const params = {
      app_id: appId
    }
    USERAPI.getUserRoles(params).then((res) => {
      if (res.stat) {
        const userRole = String(res.data.role)
        setRole(userRole)
        UserModule.setUserRole(userRole)
        setuserCurrentApp(appId)
        setuserCurrentAppName(item.name)
        const path = item.name === dashboardTicketKeywords ? '/dashboard' : '/'
        if (item.path) {
          this.$router
            .replace({
              path: item.path,
              query: { t: String(new Date().getTime()) }
            })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => {})
        } else {
          this.$router
            .replace({
              path: path,
              query: { t: String(new Date().getTime()) }
            })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => {})
        }
      } else {
        this.$alert('获取登录用户身份出错！', {
          type: 'warning',
          confirmButtonText: '知道了'
        })
      }
    })
  }

  private checkDashPerms() {
    // 根据需求，要求有dashboard展示权限的，直接进入dashboard页面，切换其他工单的再自己选择进入哪个工单模块
    const checkDashPerms = this.$route.query.check_dash_perms || 'true'

    return new Promise((resolve, reject) => {
      if (checkDashPerms === 'true' && !this.isMobile) {
        SYSAPI.getDashPerms().then((res) => {
          if (res.stat && JSON.stringify(res.data) !== '{}') {
            const userRole = String(res.data.role)
            setRole(userRole)
            UserModule.setUserRole(userRole)
            setuserCurrentApp(res.data.app_id)
            setuserCurrentAppName(res.data.name)
            this.$router
              .replace({
                path: '/dashboard',
                query: { t: String(new Date().getTime()) }
              })
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              .catch(() => {})
          } else {
            resolve()
          }
        })
      }
      resolve()
    })
  }
}
